import { type ChangeEvent } from "react"
import { Textarea } from "@/components/ui/textarea"
import { Label } from "@/components/ui/label"
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"
import { Key } from "lucide-react"

interface ConfigurationSdkTokenProps {
  data: any
  onChange: (data: any) => void
  onValid: (valid: boolean) => void
}

export const ConfigurationSdkToken = ({ data, onChange }: ConfigurationSdkTokenProps) => {
  return (
    <div className="max-w-2xl">
      <Card>
        <CardHeader className="pb-3">
          <div className="flex items-center gap-2">
            <Key className="size-4 text-muted-foreground" />
            <CardTitle className="text-sm font-medium">SDK Token</CardTitle>
          </div>
          <CardDescription className="text-xs">
            The SDK token used to authenticate the widget with the Banuba SDK
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="flex flex-col gap-1.5">
            <Label htmlFor="sdkToken" className="text-xs">
              Token <span className="text-destructive">*</span>
            </Label>
            <Textarea
              id="sdkToken"
              name="sdkToken"
              rows={4}
              className="font-mono text-xs"
              placeholder="Paste your SDK token here..."
              onChange={(e: ChangeEvent<HTMLTextAreaElement>) =>
                onChange({ ...data, sdkToken: e.target.value })
              }
              value={data.sdkToken}
            />
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
